module.exports = __webpack_public_path__ + "img/category6.02e93108.jpg";